/* SWEATORJOY homepage
   Reveal on scroll, the hero pose swap, the heart burst on the collection
   boxes, and the drop-photo carousels shared by the hero corner browser,
   the full-screen hero stage, and the Christian Wear box. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- reveal on scroll ---------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- hero pose swap on hover ---------------- */
  (function () {
    var media = document.querySelector('.hero-media');
    var link = document.querySelector('.hero-link');
    if (!media || !link) return;
    ['mouseenter', 'focus'].forEach(function (ev) {
      link.addEventListener(ev, function () { media.classList.add('alt'); });
    });
    ['mouseleave', 'blur'].forEach(function (ev) {
      link.addEventListener(ev, function () { media.classList.remove('alt'); });
    });
  })();

  /* ---------------- heart burst on the collection boxes ---------------- */
  (function () {
    if (reduceMotion || !Element.prototype.animate) return;
    var PINKS = ['#FF3D71', '#FF5A8A', '#FF7BA6', '#F58AA0', '#E8467A', '#FFA3C0'];

    function heart(x, y) {
      var el = document.createElement('span');
      var size = 14 + Math.random() * 22;
      el.style.cssText =
        'position:fixed;left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size +
        'px;pointer-events:none;z-index:400;color:' + PINKS[Math.floor(Math.random() * PINKS.length)] + ';';
      el.innerHTML =
        '<svg viewBox="0 0 24 24" fill="currentColor" style="width:100%;height:100%">' +
        '<path d="M12 21s-7-4.6-7-9.6A4 4 0 0 1 12 8a4 4 0 0 1 7 3.4c0 5-7 9.6-7 9.6z"/></svg>';
      document.body.appendChild(el);

      var dx = (Math.random() - 0.5) * 260;
      var dy = -140 - Math.random() * 220;
      var rot = (Math.random() - 0.5) * 120;
      el.animate([
        { transform: 'translate(0,0) rotate(0deg) scale(.4)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot + 'deg) scale(1)', opacity: 0 }
      ], { duration: 900 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)' })
        .onfinish = function () { el.remove(); };
    }

    document.querySelectorAll('.collection-box-bety, .collection-box-christian').forEach(function (box) {
      box.addEventListener('click', function (e) {
        var href = box.getAttribute('href');
        var rect = box.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        for (var i = 0; i < 18; i++) {
          setTimeout(function () { heart(cx, cy); }, i * 26);
        }
        if (href && href !== '#') {
          e.preventDefault();
          setTimeout(function () { window.location.href = href; }, 340);
        }
      });
    });
  })();

  /* ---------------- drop photo carousels ---------------- */
  function boot() {
    var tpl = document.getElementById('dropPhotos');
    if (!tpl) return;
    var photos = Array.prototype.slice.call(tpl.content.querySelectorAll('.drop-photo'));
    if (!photos.length) return;

    function fill(strip) {
      photos.forEach(function (p) { strip.appendChild(p.cloneNode(true)); });
    }

    function buildDots(host, onPick) {
      host.innerHTML = '';
      photos.forEach(function (_, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = n === 0 ? 'on' : '';
        b.setAttribute('aria-label', 'Photo ' + (n + 1));
        b.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation(); onPick(n);
        });
        host.appendChild(b);
      });
    }

    /* one photo means there is nothing to page through */
    function single(els) {
      if (photos.length > 1) return false;
      els.forEach(function (el) { if (el) el.style.display = 'none'; });
      return true;
    }

    /* collection box */
    var cbStrip = document.getElementById('cbSlides');
    if (cbStrip) {
      fill(cbStrip);
      var cbPrev = document.getElementById('cbPrev');
      var cbNext = document.getElementById('cbNext');
      var cbDots = document.getElementById('cbDots');
      var ci = 0;
      var cbGo = function (n) {
        ci = (n + photos.length) % photos.length;
        cbStrip.style.transform = 'translateX(' + (-ci * 100) + '%)';
        cbDots.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('on', k === ci); });
      };
      if (!single([cbPrev, cbNext, cbDots])) {
        buildDots(cbDots, cbGo);
        cbNext.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); cbGo(ci + 1); });
        cbPrev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); cbGo(ci - 1); });
      }
    }

    /* hero corner browser and the stage behind it */
    var cStrip = document.getElementById('heroSwapStrip');
    var hStrip = document.getElementById('heroStrip');
    var media = document.querySelector('.hero-media');
    if (!cStrip || !hStrip || !media) return;
    fill(cStrip);
    fill(hStrip);

    var hPrev = document.getElementById('heroSwapPrev');
    var hNext = document.getElementById('heroSwapNext');
    var hDots = document.getElementById('heroSwapDots');
    var openBtn = document.getElementById('heroSwapOpen');
    var label = document.getElementById('heroSwapLabel');
    var hi = 0;
    var swapped = false;
    var caption = label ? label.textContent : '';

    function heroGo(n) {
      hi = (n + photos.length) % photos.length;
      var x = 'translateX(' + (-hi * 100) + '%)';
      cStrip.style.transform = x;
      hStrip.style.transform = x;      /* corner and stage stay on the same photo */
      hDots.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('on', k === hi); });
      if (!swapped && label) label.textContent = photos[hi].dataset.caption || caption;
    }

    if (!single([hPrev, hNext, hDots])) {
      buildDots(hDots, heroGo);
      hNext.addEventListener('click', function (e) { e.preventDefault(); heroGo(hi + 1); });
      hPrev.addEventListener('click', function (e) { e.preventDefault(); heroGo(hi - 1); });
    }

    openBtn.addEventListener('click', function () {
      swapped = !swapped;
      media.classList.toggle('swapped', swapped);
      openBtn.setAttribute('aria-pressed', swapped ? 'true' : 'false');
      openBtn.setAttribute('aria-label', swapped ? 'Go back to the hero image' : 'Show this photo full screen');
      if (label) label.textContent = swapped ? 'Back' : (photos[hi].dataset.caption || caption);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
